/**
 * Package Button Active Class Toggle
 * Adds active class to clicked button and removes from others
 */

(function() {
  function setupButtonActiveClass() {
    // Find all package button parents
    const buttonParents = document.querySelectorAll('.package-btn-parent, .standard-btn-parent, .premium-btn-parent, .premium-women-btn-parent, .premium-men-btn-parent');
    
    if (buttonParents.length === 0) {
      // If no parent classes found, try to find buttons by text content
      const ourPackagesHeading = Array.from(document.querySelectorAll('h2, h3, h4')).find(
        el => {
          const text = el.textContent.trim().toLowerCase();
          return text === 'our packages' || text.includes('our packages');
        }
      );

      if (ourPackagesHeading) {
        const section = ourPackagesHeading.closest('section, [class*="section"]');
        if (section) {
          const allGroups = section.querySelectorAll('[class*="group"]');
          allGroups.forEach(group => {
            const textElement = group.querySelector('p');
            if (textElement) {
              const text = textElement.textContent.trim().toLowerCase();
              if (text === 'standard' || text === 'premium' || text.includes('premium plus')) {
                const parentGroupBlock = group.closest('.group-block') || group;
                if (parentGroupBlock && !parentGroupBlock.classList.contains('package-btn-parent')) {
                  parentGroupBlock.classList.add('package-btn-parent');
                }
              }
            }
          });
        }
      }
      
      // Try again after adding classes
      const updatedButtonParents = document.querySelectorAll('.package-btn-parent');
      if (updatedButtonParents.length > 0) {
        addClickHandlers(Array.from(updatedButtonParents));
        return;
      }
    } else {
      addClickHandlers(Array.from(buttonParents));
    }
  }

  function addClickHandlers(buttonParents) {
    // Find the section containing products
    const ourPackagesHeading = Array.from(document.querySelectorAll('h2, h3, h4')).find(
      el => {
        const text = el.textContent.trim().toLowerCase();
        return text === 'our packages' || text.includes('our packages');
      }
    );

    const section = ourPackagesHeading ? ourPackagesHeading.closest('section, [class*="section"]') : document;

    // Store button data before cloning
    const buttonData = [];
    
    buttonParents.forEach((buttonParent, index) => {
      // Determine content class to show based on button (before cloning)
      let contentClassToShow = null;
      if (buttonParent.classList.contains('standard-btn-parent')) {
        contentClassToShow = 'standard-content';
      } else if (buttonParent.classList.contains('premium-btn-parent')) {
        contentClassToShow = 'premium-content';
      } else if (buttonParent.classList.contains('premium-women-btn-parent')) {
        contentClassToShow = 'premium-women-content';
      } else if (buttonParent.classList.contains('premium-men-btn-parent')) {
        contentClassToShow = 'premium-men-content';
      } else {
        // Fallback: get from button text
        const buttonText = buttonParent.querySelector('p')?.textContent.trim().toLowerCase() || '';
        if (buttonText === 'standard') {
          contentClassToShow = 'standard-content';
        } else if (buttonText === 'premium' && !buttonText.includes('plus')) {
          contentClassToShow = 'premium-content';
        } else if (buttonText.includes('premium plus women') || (buttonText.includes('premium') && buttonText.includes('women'))) {
          contentClassToShow = 'premium-women-content';
        } else if (buttonText.includes('premium plus men') || (buttonText.includes('premium') && buttonText.includes('men'))) {
          contentClassToShow = 'premium-men-content';
        }
      }
      
      buttonData.push({ element: buttonParent, contentClass: contentClassToShow, index: index });
    });

    // Clone buttons and add handlers
    const clonedButtons = [];
    buttonData.forEach(({ element: buttonParent, contentClass: contentClassToShow }) => {
      // Make it clickable
      buttonParent.style.cursor = 'pointer';
      
      // Remove any existing click handlers by cloning the element
      const newButtonParent = buttonParent.cloneNode(true);
      buttonParent.parentNode.replaceChild(newButtonParent, buttonParent);
      clonedButtons.push(newButtonParent);
      
      // Add click handler
      newButtonParent.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Remove active class from all buttons
        const allButtons = document.querySelectorAll('.package-btn-parent');
        allButtons.forEach(btn => {
          btn.classList.remove('package-btn-parent-active');
        });
        
        // Add active class to clicked button
        this.classList.add('package-btn-parent-active');
        
        // Show/hide content based on button clicked
        if (contentClassToShow) {
          toggleContent(contentClassToShow, section);
        }
      });
    });
    
    // Set first button as active by default
    if (clonedButtons.length > 0 && buttonData.length > 0) {
      const firstButton = clonedButtons[0];
      const firstButtonData = buttonData[0];
      
      // Ensure we have valid button and data
      if (firstButton && firstButtonData && firstButtonData.contentClass) {
        setTimeout(() => {
          // Remove active class from all buttons first
          const allButtons = document.querySelectorAll('.package-btn-parent');
          allButtons.forEach(btn => {
            btn.classList.remove('package-btn-parent-active');
          });
          
          // Add active class to first button
          firstButton.classList.add('package-btn-parent-active');
          
          // Show corresponding content
          toggleContent(firstButtonData.contentClass, section);
        }, 600);
      }
    }
  }

  function toggleContent(activeContentClass, section) {
    // All content classes
    const allContentClasses = [
      'standard-content',
      'premium-content',
      'premium-women-content',
      'premium-men-content'
    ];
    
    // Find all elements with content classes within the section
    allContentClasses.forEach(contentClass => {
      const elements = section.querySelectorAll(`.${contentClass}`);
      elements.forEach(element => {
        // Find the parent element (group-block, slideshow-slide, or product card container)
        const parentElement = element.closest('.group-block, slideshow-slide, .product-grid__item, [class*="product-card"], [class*="product"]') || 
                             element.parentElement;
        
        if (parentElement) {
          if (contentClass === activeContentClass) {
            // Show matching content's parent
            parentElement.style.display = '';
            parentElement.removeAttribute('hidden');
            parentElement.setAttribute('aria-hidden', 'false');
            parentElement.classList.remove('package-content-hidden');
          } else {
            // Hide non-matching content's parent
            parentElement.style.display = 'none';
            parentElement.setAttribute('hidden', 'true');
            parentElement.setAttribute('aria-hidden', 'true');
            parentElement.classList.add('package-content-hidden');
          }
        }
      });
    });
  }

  // Initialize when DOM is ready
  function init() {
    setTimeout(() => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupButtonActiveClass);
      } else {
        setupButtonActiveClass();
      }
    }, 300);
  }

  init();

  // Also run when content is dynamically loaded (for Shopify theme editor)
  if (document.addEventListener) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(setupButtonActiveClass, 400);
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(setupButtonActiveClass, 400);
    });
  }
})();
